// import { state } from "./mutations";

export default {
    // experimentName: state => state.experimentName,
    // trades: state => state.trades,

}